import { render, staticRenderFns } from "./CellFixedTablesMember.vue?vue&type=template&id=cb4ccf28&scoped=true&"
import script from "./CellFixedTablesMember.vue?vue&type=script&lang=js&"
export * from "./CellFixedTablesMember.vue?vue&type=script&lang=js&"
import style0 from "./CellFixedTablesMember.vue?vue&type=style&index=0&id=cb4ccf28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4ccf28",
  null
  
)

export default component.exports